import { setShare, getShareConfig as webxGetShareConfig, canIUse } from '@didi/webx-js'
import { getUrlParams, getPubData } from '../../../utils.js'

const shareMsg = {
  appid: 'gh_7a5c4141778f'
}

export const getShareConfig = async () => {
  try {
    const newXid = getPubData('xid')
    const { dchn, xid } = getUrlParams()
    const res = await webxGetShareConfig({
      args: {
        dchn: dchn,
        xid: newXid || xid,
        invoke_key: 'default'
      }
    }, process.env.WEBX_ENV)
    const shareData = res?.conf
    if (shareData) {
      shareData.channels.wx_appmsg.forEach(item => {
        if (item.xenv === 'passenger' && item.share_type === 'miniApp') {
          item.appid = shareMsg.appid
        }
      })
      canIUse('setShare') && setShare(shareData)
    }
  } catch (error) {
    console.log('error: ', error)
  }
}
